(function () {
  'use strict';

  angular.module('MktzapApp.Controllers')
    .controller('NotificationsTrackerSettingsController', notificationsTracker);

  notificationsTracker.$inject = ['$rootScope', 'CompanyService', 'NotificationService'];

  function notificationsTracker ($rootScope, CompanyService, NotificationService) {
    var vmNotificationsTrackerSettingsCtrl = this;

    $rootScope.getPageLabels('menu.config.notificationTracker');

    CompanyService
      .loadMetadata()
      .$promise
      .then(function (data) {
        vmNotificationsTrackerSettingsCtrl.metadata = data;
      })
      .catch(function (error) {
        NotificationService.errorHandler(error, $rootScope.labels.errorMetadata);
      });

    vmNotificationsTrackerSettingsCtrl.allow = function (key) {
      CompanyService
        .saveMetadata(vmNotificationsTrackerSettingsCtrl.metadata)
        .$promise
        .then(function (data) {
          $rootScope.company_metadata = vmNotificationsTrackerSettingsCtrl.metadata;
          NotificationService.successHandler(data, $rootScope.labels.configUpdated);
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, $rootScope.labels.notActive);
        });
    };
  }
})();
